var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36914 0.727051C11.4391 0.727051 14.739 4.02629 14.7393 8.09619C14.7393 11.5905 12.3066 14.5149 9.04297 15.2729V12.5347C9.04282 11.621 8.30233 10.8804 7.38867 10.8804H7.1123C6.19881 10.8806 5.45815 11.6212 5.45801 12.5347V15.2134C2.31493 14.3713 0 11.5049 0 8.09619C0.000230626 4.02643 3.29938 0.727281 7.36914 0.727051ZM6.56152 5.9165C5.95232 5.9165 5.45801 6.41082 5.45801 7.02002V8.39893C5.45816 9.008 5.95241 9.50146 6.56152 9.50146H7.94043C8.54938 9.50128 9.04282 9.00788 9.04297 8.39893V7.02002C9.04297 6.41093 8.54947 5.91669 7.94043 5.9165H6.56152Z",
    fill: "#D8B391"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.16eb1048153d58d858e658c4f945ac06.svg";
export { ForwardRef as ReactComponent };